import { listDaysFromDate } from "../helpers";

// NOTE: ALWAYS BE MINDFUL OF THE NEED TO REPLACE SPACES WITH TABS IN SOME FIELDS!!!

const doUpdateTemplate = `<?xml version="1.0" encoding="UTF-8"?>
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:ENC="http://schemas.xmlsoap.org/soap/encoding/" xmlns:tns="http://com.wms.cash" encodingStyle="http://schemas.xmlsoap.org/soap/encoding/">
      <soapenv:Body>
        <tns:doUpdate>
          <cmdName xsi:type="ENC:Array" ENC:arrayType="xsd:string[{{cmditemscount}}]">
            {{cmditems}}
          </cmdName>
          <params xsi:type="ENC:Array" ENC:arrayType="xsd:string[{{paramitemscount}}]">
            {{paramitems}}
          </params>
          <pTypes xsi:type="ENC:Array" ENC:arrayType="xsd:string[{{ptypeitemscount}}]">
            {{ptypeitems}}
          </pTypes>
        </tns:doUpdate>
      </soapenv:Body>
    </soapenv:Envelope>`;

export default class SoapDoUpdateCommand {
  constructor() {
    this.reset();
  }

  reset() {
    //ONLY USEFUL IN CASE WE USE THE INSTANCE BACK TO BACK
    this.commands = [];
    this.params = [];
    this.types = [];
  }

  addSoapCommandEntry(cmd, param, type) {
    this.commands.push(`<item xsi:type="xsd:string">${cmd}</item>`);

    this.params.push(`<item xsi:type="xsd:string">${param.replace(/\s+/g, "\t")}</item>`);

    this.types.push(`<item xsi:type="xsd:string">${type.replace(/\s+/g, "\t")}</item>`);
  }

  generateMessage() {
    let result = doUpdateTemplate
      .replace("{{cmditemscount}}", this.commands.length)
      .replace("{{paramitemscount}}", this.params.length)
      .replace("{{ptypeitemscount}}", this.types.length)

      .replace("{{cmditems}}", this.commands.join(""))
      .replace("{{paramitems}}", this.params.join(""))
      .replace("{{ptypeitems}}", this.types.join(""));

    this.reset();
    return result;
  }

  buildGetPaymentsForClient(clientID, startDate = null, endDate = null) {
    startDate = isNaN(Date.parse(startDate)) ? new Date() : new Date(startDate);
    endDate = isNaN(Date.parse(endDate)) ? new Date() : new Date(endDate);

    startDate = `${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
    endDate = `${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;

    this.addSoapCommandEntry(
      "wtr_select_eft_clitems",
      `${clientID} ${startDate} ${endDate}`,
      "integer date date"
    );
  }

  buildReleasePaymentForClient(paymentId, userName) {
    this.addSoapCommandEntry(
      "wtr_release2",
      `${paymentId} 1 ${userName}`,
      "integer integer string"
    );
  }

  buildGetLedgerEntriesForAccount(accountId, ledgerTag, forDate = null) {
    // 'accountId' is not the same as 'acctCode' in other places
    //DETAIL: `ledgerTag` usually follows the pattern of ("CAS" + `acctCode`)
    let curDate = isNaN(Date.parse(forDate)) ? new Date() : new Date(forDate);

    forDate = `${curDate.getFullYear()}-${curDate.getMonth() + 1}-${curDate.getDate()}`;

    this.addSoapCommandEntry(
      "cl_select_account_for_ws",
      `${ledgerTag} ${accountId} ${forDate} ${forDate}`,
      "string integer date date"
    );
  }

  buildGetLedgerEntriesForMultipleAccounts(accountIdArray, forDate = null) {
    // 'accountId' is not the same as 'acctCode' in other places
    //DETAIL: `ledgerTag` usually follows the pattern of ("CAS" + `acctCode`)
    accountIdArray.forEach((acctId) => {
      this.buildGetLedgerEntriesForAccount(acctId, `CAS${acctId}`, forDate);
    });
  }

  buildGetWorksheetDetailsForTransaction(ledgerRID) {
    //DETAIL: ASSUMES LEDGER ENTRY 'rid' IS UNIQUE FOR ACCOUNTS AND DATES
    this.addSoapCommandEntry("cl_get_cash_worksheet_details", `${ledgerRID}`, "integer");
  }

  buildGetWorksheetDetailsForMultipleTransactions(ledgerRIDArray) {
    //DETAIL: ASSUMES LEDGER ENTRY 'rid' IS UNIQUE FOR ACCOUNTS AND DATES
    ledgerRIDArray.forEach((rid) => {
      this.buildGetWorksheetDetailsForTransaction(rid);
    });
  }

  buildGetBankDetailsForAccount(accountId, forDate = null) {
    // 'accountId' is not the same as 'acctCode' in other places
    //DETAIL: `ledgerTag` usually follows the pattern of ("CAS" + `acctCode`)
    let curDate = isNaN(Date.parse(forDate)) ? new Date() : new Date(forDate);
    forDate = `${curDate.getFullYear()}-${curDate.getMonth() + 1}-${curDate.getDate()}`;

    this.addSoapCommandEntry("cl_bank_detail_select", `${accountId} ${forDate}`, "integer date");
  }

  buildStandardDashboardAccountSummaryCommand(accountIdArray, forDate = null) {
    let curDate = isNaN(Date.parse(forDate)) ? new Date() : new Date(forDate);
    forDate = `${curDate.getFullYear()}-${curDate.getMonth() + 1}-${curDate.getDate()}`;

    if (Array.isArray(accountIdArray)) {
      accountIdArray.forEach((acctId, idx) => {
        this.addSoapCommandEntry(
          "dash_get_cash",
          `${acctId} ${forDate} `, // NOTE: THERE IS AN INTENTIONAL SPACE *AFTER* THE DATE PARAM
          "integer date string"
        );
      });
    }
  }

  buildGetCashPositionOpeningBalances(accountId, startDate = null, daysOut = 7) {
    startDate = isNaN(Date.parse(startDate)) ? new Date() : new Date(startDate);
    daysOut = Math.max(1, daysOut);

    let dateArray = listDaysFromDate(startDate, daysOut, true);

    const beginDate = dateArray[0];
    const dateList = dateArray.join(" ");
    const datePlaceholderString = "date ".repeat(Math.max(1, dateArray.length));

    this.addSoapCommandEntry(
      "cpos_opening_available2",
      `${accountId} ${dateList}`,
      `integer ${datePlaceholderString}`
    );

    this.addSoapCommandEntry("cpos_inv_sweep_bal", `${accountId} ${beginDate}`, "integer date");
  }

  buildGetCashPositionActivity(accountId, clientId, startDate = null, daysOut = 7) {
    startDate = isNaN(Date.parse(startDate)) ? new Date() : new Date(startDate);
    daysOut = Math.max(1, daysOut);

    let dateArray = listDaysFromDate(startDate, daysOut, true);

    const beginDate = dateArray[0];
    const endDate = dateArray[dateArray.length - 1];
    const dateList = dateArray.join(" ");
    const datePlaceholderString = "date ".repeat(Math.max(0, dateArray.length));

    this.addSoapCommandEntry("cpos_cdr_select_cashin", `${accountId} ${beginDate}`, "integer date");
    this.addSoapCommandEntry(
      "cpos_cdr_select_cashout",
      `${accountId} ${beginDate}`,
      "integer date"
    );

    this.addSoapCommandEntry(
      "cpos_pdr_unrecon_select_cashin",
      `${accountId} ${beginDate} ${endDate}`,
      "integer date date"
    );

    this.addSoapCommandEntry(
      "cpos_pdr_unrecon_select_cashout",
      `${accountId} ${beginDate} ${endDate}`,
      "integer date date"
    );

    this.addSoapCommandEntry(
      "cpos_cl_select",
      `${accountId} ${beginDate} ${endDate}`,
      "integer date date"
    );

    this.addSoapCommandEntry(
      "cpos_checkrun_select",
      `${accountId} ${beginDate} ${endDate}`,
      "integer date date"
    );

    this.addSoapCommandEntry(
      "cpos_mmf_balance2",
      `${dateList} ${clientId}`,
      `${datePlaceholderString} integer`
    );
  }
}
